import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const ZIP_CODE_REGEX = new RegExp(/(^([0-9]){5}$)|(^([0-9]){5}-([0-9]){4}$)/);

export function zipCodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const isValid = control.value.match(ZIP_CODE_REGEX);
    return isValid ? null : { invalid: true };
  };
}
